export default "__VITE_ASSET__B_Ej7HAB__"